{
  "translation": {
    "attribute photo": "Photo by {{author}} on {{platform}}.",
    "home": {
      "welcome to": "Welcome to {{name}}.",
      "start": "Start Planning",
      "why": {
        "why": "Why {{name}}?",
        "1": "Calculates the most efficient panel positioning.",
        "2": "Estimates costs over time.",
        "3": "Factors latitude, direction and more.",
        "4": "100% free and easy to use."
      }
    },
    "404": {
      "not found": "Hmm, this page wasn't found",
      "go home": "Return Home"
    },
    "about": {
      "title": "About ",
      "repo": "View the repository on GitHub.",
      "changelog": "View the changelog.",
      "made with": "Made with",
      "authors": "Made with <0></0> by {{authors}}.",
      "exit": "Click anywhere to exit."
    },
    "planner": {
      "next step": "Next Step",
      "location": {
        "title": "Location Setup",
        "latitude": "The latitude of your building.",
        "shading": "How much cover obstructs your roof.",
        "direction": "Direction of your roof."
      },
      "finance": {
        "title": "Finance Setup",
        "energy usage": "How much energy your household consumes annually.",
        "energy cost": "Cost of 1kWh of energy.",
        "seg": "How much you are paid for 1kWh of excess electricity.",
        "seg info": "What is Smart Export Guarantee?",
        "seg desc": "Smart Export Guarantee is a government mandated scheme that provides a way for your excess solar energy to be exported to the national grid and recieving payment from electricity suppliers.",
        "energy info": "How do I find my Energy Cost/Usage?",
        "energy desc": "This information is avaliable from your energy bills or contacting your energy supplier."
      },
      "roof": {
        "title": "Roof Sections",
        "add section": "Add Section"
      },
      "overview": {
        "title": "Select Panels and Overview",
        "panels": "Panels",
        "overview": "Overview",
        "roof area": "Roof Area: {{area}}m²",
        "panel area_one": "Panel Area: {{area}}m² ({{count}} panel, <0>{{efficiency}}% space efficiency</0>)",
        "panel area_other": "Panel Area: {{area}}m² ({{count}} panels, <0>{{efficiency}}% space efficiency</0>)",
        "initial cost": "Initial Cost: £{{cost}}",
        "labor cost": "Labor Cost: £{{cost}}",
        "estimated energy": "Estimated Energy: {{energy}}kW ({{efficiency}}% efficiency)",
        "annual energy": "Annual Energy: {{energy}}kWh",
        "annual profits": "Annual Profits: £{{profit}}",
        "return on investment": "Return on Investment: {{roi}} years",
        "best": "Best annual profits",
        "annual savings": "Annual Savings: £{{saving}}",
        "error no sections": "No roof sections have been created yet.",
        "error no space": "No panels of this type are able to fit."
      }
    },
    "common": {
      "tagline": "The most advanced solar panel planner.",
      "latitude": "Latitude",
      "shading": "Shading",
      "direction": "Direction",
      "energy usage": "Energy Usage",
      "energy cost": "Energy Cost",
      "seg": "Smart Export Guarantee",
      "width": "Width",
      "height": "Height",
      "gradient": "Gradient",
      "dimensions": "Dimensions",
      "area": "Area",
      "price": "Price"
    },
    "adjs": {
      "none": "None",
      "little": "Very little",
      "modest": "Modest",
      "significant": "Significant",
      "heavy": "Heavy",
      "full": "Fully Covered"
    },
    "geo": {
      "northern": "Northern",
      "southern": "Southern",
      "equator": "Equator",
      "n": "North",
      "ne": "North East",
      "e": "East",
      "se": "South East",
      "s": "South",
      "sw": "South West",
      "w": "West",
      "nw": "North West"
    }
  }
}
